import { IconButton } from "@material-ui/core";
import { KeyboardArrowLeft, KeyboardArrowRight, FiberManualRecord } from "@material-ui/icons";

interface IButtonParams {
    isEnabled: boolean;
    onClick(): void;
}

export const PreviousButton = (props: IButtonParams) => {
    const { isEnabled, onClick } = props;

    return (
        <IconButton aria-label="prev-button" className="button button-prev" disabled={!isEnabled} onClick={onClick}>
            <KeyboardArrowLeft color={isEnabled ? "primary" : "disabled"} />
        </IconButton>
    );
};

export const NextButton = (props: IButtonParams) => {
    const { isEnabled, onClick } = props;

    return (
        <IconButton aria-label="next-button" className="button button-next" disabled={!isEnabled} onClick={onClick}>
            <KeyboardArrowRight color={isEnabled ? "primary" : "disabled"} />
        </IconButton>
    );
};

export const StepButton = (props: IButtonParams) => {
    const { isEnabled, onClick } = props;

    return (
        <IconButton aria-label="step-button" className="button button-step" onClick={onClick}>
            <FiberManualRecord color={isEnabled ? "secondary" : "disabled"} fontSize="small" />
        </IconButton>
    );
};
